import { HarmonizedViolationAssigneeSource } from "generated-graphql/graphql";

/**
 * Where a violation's effective assignee came from, or nothing at all when the
 * field didn't resolve.
 */
export type AssigneeSource = HarmonizedViolationAssigneeSource | null | undefined;

/** The scope a default belongs to, backing the grid cell's inheritance hint. */
export function assigneeSourceScopeLabel(source: AssigneeSource): string | null {
  switch (source) {
    case HarmonizedViolationAssigneeSource.Facility:
      return "facility default";
    case HarmonizedViolationAssigneeSource.Region:
      return "region default";
    case HarmonizedViolationAssigneeSource.BusinessUnit:
      return "business unit default";
    default:
      return null;
  }
}

/**
 * The grid cell's short parenthetical — "(region default)" — or null when there
 * is nothing to caption.
 */
export function assigneeInheritanceHint(source: AssigneeSource): string | null {
  const label = assigneeSourceScopeLabel(source);
  return label ? `(${label})` : null;
}
